﻿/**
 * Route State & Browser Navigation Hook
 * Connect Source Architecture
 */

import { useState, useEffect, useCallback } from 'react';
import { trackPageView } from '../analytics/events';

export function useRoute(initialPath?: string) {
  const getPath = () => {
    if (typeof window !== 'undefined') {
      return window.location.pathname || '/';
    }
    return initialPath || '/';
  };

  const [currentPath, setCurrentPath] = useState<string>(getPath);

  const navigate = useCallback((path: string) => {
    if (typeof window !== 'undefined') {
      if (window.location.pathname !== path) {
        window.history.pushState({}, '', path);
      }
      window.scrollTo(0, 0);
    }
    setCurrentPath(path);
    trackPageView(path);
  }, []);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handlePopState = () => {
      const newPath = window.location.pathname || '/';
      setCurrentPath(newPath);
      trackPageView(newPath);
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  return {
    currentPath,
    navigate
  };
}

